<template>
    <div class="">
        <trashed-message v-if="jobOffer.deleted_at" class="mb-6" @restore="restore">
            This Job offer has been deleted.
        </trashed-message>

        <div class="flex justify-between items-center">
            <breadcrumbs>
                <inertia-link href="/joboffers">Vacatures</inertia-link>
                <i class="fad fa-chevron-right"></i>
                {{ jobOffer.title }}
            </breadcrumbs>
        </div>

        <div class="flex justify-between items-center">
            <h1 class="text-5xl text-teal-800 truncate">
                {{ jobOffer.title }}
            </h1>
        </div>

        <div class="flex">
            <div class="w-2/3 bg-white px-5 py-5 rounded ">
                <job-offer :job-offer="jobOffer" :tags="tags" :jobtemplates="jobtemplates" :hideTitle="true" :editable="true" />
            </div>

            <div class="w-1/3 ml-10">
                <div class="sticky top-0">
                    <div class="mb-5 bg-white px-5 py-5 rounded text-center">
                        <button v-if="nextPrev.prev" @click.prevent="gotoPrevJobOffer()" class="bg-gray-200 px-3 py-1 rounded hover:underline">
                            <i class="fad mr-1" :class="loading === 'gotoPrev' ? 'fa-spinner fa-pulse' : 'fa-chevron-left'"></i>Vorige
                        </button>
                        <button v-if="nextPrev.next" @click.prevent="gotoNextJobOffer()" class="bg-gray-200 px-3 py-1 rounded hover:underline">
                            Volgende<i class="fad fa-chevron-right ml-1" :class="loading === 'gotoNext' ? 'fa-spinner fa-pulse' : 'fa-chevron-left'"></i>
                        </button>
                    </div>

                    <div class="mb-5 bg-white px-5 py-5 rounded">
                        <h2 class="text-2xl text-teal-800 text-center">Toon op de site? (publiceer?)</h2>

                            <div class="mt-3 text-center space-x-5">
                            <button
                                class="px-3 py-1 rounded hover:text-white hover:bg-red-800"
                                :class="jobOffer.reviewed && !jobOffer.published ? 'bg-red-500 text-white font-bold' : 'bg-red-100'"
                                @click.prevent="publish(false)"
                            >
                                <i class="fad mr-1" :class="loading === 'publishfalse' ? 'fa-spinner fa-pulse' : 'fa-thumbs-down'"></i>Nee
                            </button>

                            <button
                                class="px-3 py-1 rounded hover:text-white hover:bg-green-800"
                                :class="jobOffer.reviewed && jobOffer.published ? 'bg-green-500 text-white font-bold' : 'bg-green-100'"
                                @click.prevent="publish(true)"
                            >
                                <i class="fad mr-1" :class="loading === 'publishtrue' ? 'fa-spinner fa-pulse' : 'fa-thumbs-up'"></i>Ja
                            </button>
                        </div>
                    </div>

                    <div class="bg-white px-5 py-5 rounded">
                        <h2 class="text-2xl text-teal-800">Bron pagina</h2>

                        <div v-if="!jobOffer.scraper_page">Bestaat niet meer</div>
                        <div v-else>
                            <div>
                                <div class="mb-3">
                                    <a :href="jobOffer.scraper_page.url" rel="noopener noreferrer" class="hover:underline" target="_blank">{{ jobOffer.scraper_page.url }}</a>
                                </div>

                                <inertia-link :href="route('admin.scraperpages.show', jobOffer.scraper_page_id)"> <i class="fa fa-file-alt mr-1"></i>ScraperPage </inertia-link>
                            </div>

                            <div class="flex px-5 py-2 bg-teal-100 mt-3">
                                <div class="w-40">
                                    <i class="fad fa-calendar-alt mr-1"></i>
                                    Created:
                                </div>
                                <div v-if="jobOffer.scraper_page.created_at">
                                    {{ moment(jobOffer.scraper_page.created_at).fromNow(false) }}
                                </div>
                            </div>

                            <div class="flex px-5 py-2">
                                <div class="w-40">
                                    <i class="fad fa-eye mr-1"></i>
                                    Last seen:
                                </div>
                                <div
                                    v-if="jobOffer.scraper_page.last_seen_at"
                                    :class="moment().diff(moment(jobOffer.scraper_page.last_seen_at), 'hours') > 24 ? 'text-red-500' : ''"
                                >
                                    {{ moment(jobOffer.scraper_page.last_seen_at).fromNow(false) }}
                                </div>
                            </div>

                            <div class="flex px-5 py-2 bg-teal-100">
                                <div class="w-40">
                                    <i class="fad fa-download mr-1"></i>
                                    Last downloaded:
                                </div>
                                <div v-if="jobOffer.scraper_page.last_downloaded_at">
                                    {{ moment(jobOffer.scraper_page.last_downloaded_at).fromNow(false) }}
                                </div>
                            </div>

                            <div class="flex px-5 py-2">
                                <div class="w-40">
                                    <i class="fad fa-layer-plus mr-1"></i>
                                    Last parsed:
                                </div>
                                <div v-if="jobOffer.scraper_page.last_parsed_at">
                                    {{ moment(jobOffer.scraper_page.last_parsed_at).fromNow(false) }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mt-5 text-gray-500 text-sm italic text-center">
                        <div class="inline-block w-auto mx-auto">
                            <div class="font-bold mb-3"><i class="fad fa-keyboard mr-1"></i>Shortcuts:</div>
                            <div class="flex py-1 px-3 bg-white">
                                <div class="w-48 text-left">cmd + 2</div>
                                <div>Baan toekennen</div>
                            </div>
                            <div class="flex py-1 px-3 bg-white">
                                <div class="w-48 text-left">cmd + 3</div>
                                <div>Tag toevoegen</div>
                            </div>
                            <div class="flex py-1 px-3">
                                <div class="w-48 text-left">cmd + 4:</div>
                                <div>Salaris toevoegen</div>
                            </div>
                            <div class="flex py-1 px-3 bg-white">
                                <div class="w-48 text-left">cmd + arrow up</div>
                                <div>Duurzaam</div>
                            </div>
                            <div class="flex py-1 px-3">
                                <div class="w-48 text-left">cmd + arrow down</div>
                                <div>Niet duurzaam</div>
                            </div>
                            <div class="flex py-1 px-3 bg-white">
                                <div class="w-48 text-left">cmd + arrow left</div>
                                <div>Vorige</div>
                            </div>
                            <div class="flex py-1 px-3">
                                <div class="w-48 text-left">cmd + arrow right</div>
                                <div>Volgende</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import { Inertia } from "@inertiajs/inertia";
import TrashedMessage from "@/admin/Shared/TrashedMessage";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import JobOffer from "@/admin/Components/JobOffers/JobOffer";
import hotkeys from "hotkeys-js";

export default {
    metaInfo: { title: "Job offers" },

    layout: Layout,

    mixins: [Helpers],

    components: {
        TrashedMessage,
        Breadcrumbs,
        JobOffer
    },

    props: {
        jobOffer: Object,
        tags: Array,
        jobtemplates: Array,
        nextPrev: Object
    },

    data() {
        return {
            tagToAdd: ""
        };
    },

    methods: {
        getJobOfferUrl(id) {
            return route("admin.joboffers.show", id) + this.queryParams;
        },

        publish(published) {
            this.setLoading("publish" + published);

            const url = route("admin.joboffers.publish", this.jobOffer.id).url();
            const data = { published: published };

            axios.patch(url, data).then(response => {
                
                // if (this.nextPrev.next){
                //     this.gotoNextListing();
                // }else{
                    this.jobOffer.published = response.data.published;
                    this.jobOffer.published_at = response.data.published_at;
                    this.jobOffer.reviewed = response.data.reviewed;
                    this.jobOffer.reviewed_at = response.data.reviewed_at;
                    this.setLoading('');
                // }


            });
        },

        gotoPrevJobOffer() {
            if (this.nextPrev.prev) {
                this.setTempLoading("gotoPrev");
                this.$inertia.visit(route("admin.joboffers.show", this.nextPrev.prev) + this.queryParams);
            }
        },
        gotoNextJobOffer() {
            if (this.nextPrev.next) {
                this.setTempLoading("gotoNext");
                this.$inertia.visit(route("admin.joboffers.show", this.nextPrev.next) + this.queryParams);
            }
        }
    },

    computed: {
        queryParams() {
            return window.location.search;
        }
    },

    mounted() {
        hotkeys("cmd+left", (event, handler) => {
            event.preventDefault();
            this.gotoPrevJobOffer();
        });
        hotkeys("cmd+right", (event, handler) => {
            event.preventDefault();
            this.gotoNextJobOffer();
        });
        hotkeys("cmd+up", (event, handler) => {
            event.preventDefault();
            this.publish(true);
        });
        hotkeys("cmd+down", (event, handler) => {
            // event.preventDefault();
            this.publish(false);
            return false;
        });
    }
};
</script>
